<template>
  <v-dialog
    v-model="showSetting"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title>
        Settings
        <v-spacer />
        <v-btn
          icon
          @click="close()"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container class="px-0">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pb-3"
            >
              <h3>PaperCuts</h3>
              <v-autocomplete
                v-model="settingInfo.paperCut"
                clearable
                label=""
                :items="paperCutTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
                class="ma-3"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.enableFeedback"
                inset
                label="Enable Feedback"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.excludeAggregatorTax"
                inset
                label="Exclude Aggregator Tax"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.showPaymentAmount"
                label="Show Payments With Amount" 
                hide-details
                inset
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.excludeQsrTax"
                inset
                label="Exclude QSR Tax"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          @click="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          @click="updateSetting()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TemplateSettings",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    },
    templateMasters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      settingInfo: {}
    };
  },
  computed: {
    paperCutTypes() {
      console.log(this.$store.state, "TEST");
      return this.templateMasters?.paperCuts || [];
    },
    showSetting() {
      return this.show;
    }
  },
  watch: {
    show(v) {
      if (v) {
        this.settingInfo = this.settings;
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },

    updateSetting() {
      console.log(this.settingInfo, "TEST");
      this.$emit("updateSettings", this.settingInfo);
      this.close();
    }
  }
};
</script>